import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import SelectDevice from "../components/Instructions/SelectDevice/SelectDevice";
import SelectPlatform from "../components/Instructions/SelectPlatform/SelectPlatform";
import Steps from "../components/Instructions/Steps/Steps";

const Instructions = () => {
  const [wizardInstructions, setWizardInstructions] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [selectedPlatforms, setSelectedPlatforms] = useState(null);
  const [selectedSteps, setSelectedSteps] = useState(null);

  useEffect(() => {
    fetch("/json/instructions/instructions.json")
      .then((res) => res.json())
      .then((data) => {
        setWizardInstructions(data);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (selectedDevice && wizardInstructions) {
      const device = wizardInstructions.devices.find(
        (device) => device.name === selectedDevice
      );
      setSelectedPlatforms(device.platforms);
    }
  }, [selectedDevice, wizardInstructions.devices, wizardInstructions]);

  useEffect(() => {
    if (selectedPlatform && wizardInstructions) {
      const steps = wizardInstructions.instructions.filter(
        (instruction) =>
          instruction.device === selectedDevice &&
          instruction.platform === selectedPlatform
      );
      setSelectedSteps(steps[0]);
    }
  }, [selectedPlatform, selectedPlatforms, selectedDevice, wizardInstructions]);

  // if selectedDevice changed reset the selectedPlatform and selectedSteps
  useEffect(() => {
    setSelectedPlatform("");
    setSelectedSteps(null);
  }, [selectedDevice]);

  return (
    <div>
      <Box sx={{ px: 4, pt: 8 }}>
        <Typography variant="h3" className="sectionTitle">
          Instructions
        </Typography>
        <Typography sx={{ my: 4 }} variant="body1">
          Select a device/platform combo to view the setup instructions.
        </Typography>
      </Box>
      <Box>
        {isLoading ? (
          <Box sx={{ textAlign: "center" }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box>
            {wizardInstructions && (
              <SelectDevice
                devices={wizardInstructions?.devices}
                selectedDevice={selectedDevice}
                setSelectedDevice={setSelectedDevice}
              />
            )}
            {selectedDevice && selectedPlatforms && (
              <SelectPlatform
                selectedPlatforms={selectedPlatforms}
                selectedPlatform={selectedPlatform}
                setSelectedPlatform={setSelectedPlatform}
              />
            )}
            {selectedDevice && selectedPlatform && selectedSteps && (
              <Steps selectedSteps={selectedSteps} />
            )}
          </Box>
        )}
      </Box>
    </div>
  );
};

export default Instructions;
